<template>
  <div>
    <h3>
      {{ $t('message.msgNastavHodnot') }}
      <router-link
        class="underline"
        :to="{ name: linkTo }">
        {{ $t('message.lblSposobUct') }}
      </router-link>!
    </h3>
  </div>
</template>

<script>
export default {
  props: {
    linkTo: {
      type: String,
      default: null,
      required: true,
    },
  },
};
</script>
